import React from 'react';

interface LegendWithErrorComponentProps extends React.HTMLAttributes<HTMLLegendElement> {
    showError: boolean;
    feilMeldingsId: string;
    errorElement?: JSX.Element | null;
    children: JSX.Element | null;
}

function LegendWithErrorComponent({
    showError,
    errorElement,
    children,
    feilMeldingsId,
    ...restProps
}: LegendWithErrorComponentProps): JSX.Element {
    return (
        <>
            <legend {...restProps}>{children}</legend>
            <span
                id={feilMeldingsId}
                className="c-veileder__feilmeldingsomrade c-veileder__feilmeldingsomrade--under-legend"
            >
                {showError && (
                    <>
                        <span className="error-icon"></span>
                        <span className="c-veileder__feilmelding">{errorElement}</span>
                    </>
                )}
            </span>
        </>
    );
}

export { LegendWithErrorComponent };
